export default "__VITE_ASSET__A2KOP4mb__"